import React, {useState, useEffect} from 'react'
import ReactDOM from 'react-dom'
import Link from 'next/link'
import {BattleStatuses, getBattleStatus} from '@cssbattle/shared/battles'
import {Text} from '@components/Text'
import {VStack, HStack} from '@components/Stack'
import {KeyCombo} from '@components/KeyCombo'

export const MacOSDock = ({battles}) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
    return () => setMounted(false)
  }, [])

  function keyUpHandler(event) {
    if (event.key === 'b' && event.ctrlKey) {
      document.querySelector('.mac-dock-container a').focus()
      event.preventDefault()
    }

    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      // Only handle arrow keys when a dock link is focused
      const focusedLink = document.activeElement

      const isDockLink =
        focusedLink &&
        focusedLink.closest &&
        focusedLink.closest('.dock-icon-wrapper')

      if (!isDockLink) return
      event.preventDefault()

      // Get all dock links
      const dockLinks = Array.from(
        document.querySelectorAll('.dock-icon-wrapper')
      )
      const currentIndex = dockLinks.indexOf(focusedLink)

      let nextIndex
      if (event.key === 'ArrowLeft') {
        nextIndex = currentIndex > 0 ? currentIndex - 1 : dockLinks.length - 1
      } else {
        nextIndex = currentIndex < dockLinks.length - 1 ? currentIndex + 1 : 0
      }

      dockLinks[nextIndex].focus()
    }
  }
  useEffect(() => {
    window.addEventListener('keyup', keyUpHandler)
    return () => {
      window.removeEventListener('keyup', keyUpHandler)
    }
  }, [])

  const dockContent = (
    <div className="mac-dock-container">
      <div className="mac-dock">
        <div className="mac-dock-items">
          {battles.map((battle) => {
            const battleStatus = getBattleStatus(battle)

            return (
              <div key={battle.id} className="dock-item">
                <Link href={`/battle/${battle.id}`}>
                  <a className={`dock-icon-wrapper`}>
                    <div className="dock-icon">
                      {battle.levelIds && battle.levelIds[0] && (
                        <img
                          src={`/targets/${battle.levelIds[0]}.png`}
                          alt={battle.name}
                          className="icon-image"
                        />
                      )}
                    </div>

                    {battleStatus === BattleStatuses.ONGOING && (
                      <div
                        className="dock-item-status"
                        data-status={battleStatus}
                      ></div>
                    )}
                  </a>
                </Link>

                <div className={`dock-tooltip`}>
                  <div className="tooltip-content">
                    <VStack gap="0.5rem">
                      <Text
                        weight="600"
                        size={2}
                        mono={false}
                        appearance="primary"
                      >
                        #{battle.id} - {battle.name}
                      </Text>
                      <div className="tooltip-levels">
                        {battle.levelIds.map((levelId) => (
                          <Link href={`/play/${levelId}`} key={levelId}>
                            <a className="level-thumbnail">
                              <img
                                src={`/targets/${levelId}.png`}
                                alt={`Level ${levelId}`}
                                className="level-image"
                              />
                            </a>
                          </Link>
                        ))}
                      </div>
                    </VStack>
                  </div>
                  <div className="tooltip-arrow"></div>
                </div>
              </div>
            )
          })}
        </div>

        <div className="mac-dock-controls">
          <KeyCombo value="ctrl+b" />
        </div>
      </div>
    </div>
  )

  // Return null on server-side rendering
  if (!mounted) return null

  // Use portal to render the dock in the body
  return ReactDOM.createPortal(dockContent, document.body)
}
